import { useState, useEffect } from 'react';

import { Skeleton } from 'antd';
import { GoogleMap, Marker, useLoadScript, InfoWindow } from '@react-google-maps/api';

import InfoWindowBox from '../MarkerInfoBox';

import { GOOGLE_MAPS_LOADER_OPTIONS } from '../../../constants/googleMaps';

import { getMarkers } from '../../../hooks/markers';
import { StationMapWrapper } from './styles';

export const StationMap = (props) => {
  const { activeMarker, chargePoints, setActiveMarker, selectedListChargePoint, setSelectedListChargePoint } = props;
  // Configuracao unica do script, compartilhada: dois carregadores com opcoes diferentes
  // injetam dois scripts do Maps e a pagina quebra. Ver src/constants/googleMaps.ts.
  const { isLoaded } = useLoadScript(GOOGLE_MAPS_LOADER_OPTIONS);
  const [mapRef, setMapRef] = useState();
  const [center, setCenter] = useState();
  const [currentLocation, setCurrentLocation] = useState();
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const [infoWindowData, setInfoWindowData] = useState();

  const getUserCurrentLocation = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const pointers = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        setCenter(pointers);
      }, () => {
        const defaultCenter = { lat: -27.5713144, lng: -48.75047 };

        setCenter(defaultCenter);
      });
    }
  };

  const setMapLocationToDefault = () => {
    const to = currentLocation || {
      lat: -27.5713144,
      lng: -48.75047,
    };
    mapRef?.setZoom(10);
    mapRef?.panTo(to);
  };

  const handleMarkerClick = (chargePoint) => {
    setActiveMarker(chargePoint);
    const newSelectedListChargePoint = chargePoints.chargePointList.find(
      ({ chargeBoxPk }) => chargeBoxPk === chargePoint.pk,
    );
    setSelectedListChargePoint(newSelectedListChargePoint);
  };

  useEffect(() => {
    setInfoWindowData(selectedListChargePoint);
  }, [selectedListChargePoint]);

  const onMapLoad = (map) => {
    setMapRef(map);
    const bounds = new google.maps.LatLngBounds();
    getMarkers(chargePoints)?.forEach(({ position }) => bounds.extend(position));
  };

  const onUnmount = () => {
    setMapRef(null);
  };

  useEffect(() => {
    if (activeMarker?.position) {
      mapRef?.setZoom(15);
      mapRef?.panTo(activeMarker.position);
      setCenter(activeMarker.position);
      if (!showInfoWindow) setShowInfoWindow(true);
    } else {
      setMapLocationToDefault();
      if (showInfoWindow) setShowInfoWindow(false);
    }
  }, [activeMarker?.position]);

  useEffect(() => {
    if (mapRef && currentLocation) {
      mapRef?.panTo(currentLocation);
    }
  }, [mapRef, currentLocation]);

  useEffect(() => {
    const userCurrentLocation = getUserCurrentLocation();
    if (userCurrentLocation) {
      setCurrentLocation(userCurrentLocation);
    }
  }, []);

  return (
    <>
      {!isLoaded ? (
        <StationMapWrapper>
          <Skeleton active />
        </StationMapWrapper>
      ) : (
        <StationMapWrapper>
          <GoogleMap
            mapContainerClassName='map-container'
            zoom={10}
            center={center}
            onLoad={onMapLoad}
            onUnmount={onUnmount}
          >
            {getMarkers(chargePoints)?.map((chargePoint) => {
              return (
                <Marker
                  key={chargePoint.pk}
                  position={chargePoint.position}
                  icon={{
                    url: chargePoint.icon?.url?.default,
                    anchor: new google.maps.Point(25, 32),
                    scaledSize: origin === 'PLUG_SHARE' ? new google.maps.Size(17, 22) : new google.maps.Size(35, 42),
                  }}
                  onClick={() => handleMarkerClick(chargePoint)}
                  zIndex={chargePoint.origin === 'MOVE' ? 9 : 1}
                >
                  {showInfoWindow && infoWindowData && activeMarker?.pk === chargePoint.pk ? (
                    <InfoWindow
                      position={activeMarker.position}
                      onCloseClick={() => {
                        setShowInfoWindow(false);
                      }}
                    >
                      <InfoWindowBox chargePoint={infoWindowData} />
                    </InfoWindow>
                  ) : null}
                </Marker>
              );
            })}
          </GoogleMap>
        </StationMapWrapper>
      )}
    </>
  );
};

export default StationMap;
